<template>
    <div class="overlay-container">
        <slot name="default"></slot>
        <div v-show="active" class="overlay">
            <div class="overlay-inner">
                <slot name="overlay-content">
                    <div
                        class="overlay-content d-flex align-items-center"
                        :class="contentDirection === 'vertical' ? 'flex-column' : ''"
                        :id="contentId !== '' ? contentId : null"
                    >
                        <font-awesome-icon
                            class="text-secondary fa-4x fa-spin"
                            :class="contentDirection === 'vertical' ? 'mb-3' : 'me-2'"
                            :icon="['fad', 'circle-notch']"
                        />
                        <h3 class="mb-0"><strong>{{text}}</strong></h3>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OverlayContainer',
    props: {
        active: {
            type: Boolean,
            required: true
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        contentDirection: {
            type: String,
            required: false,
            default: 'vertical',
            validator(value) {
                return ['vertical', 'horizontal'].includes(value); //Enum values go here.
            }
        },
        contentId: {
            type: String,
            required: false,
            default: ''
        }
    }
};
</script>

<style lang="scss" scoped>
$overlayOpacity: 0.85;
.overlay-container {
    position: relative;

    .overlay {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        align-items: center;
        display: flex;
        justify-content: center;
        overflow: hidden;
        z-index: 1029; //one less than fixed-top, used for BookendHeader.
        background: rgba($white, $overlayOpacity);
        background: radial-gradient(circle, rgba($white, $overlayOpacity), rgba($gray-400,$overlayOpacity));
        background-size: 200% 200%;
        animation: overlay 4s linear infinite;
        border-radius: $card-border-radius;
    }

    //In order to match the border radius of the overlay to the container it's covering, the following utility classes are provided.
    &.rounded-0 .overlay {
        border-radius: 0; //No border radius on the component being covered.
    }
    &.rounded .overlay {
        border-radius: $border-radius; //Covering something with bootstrap default border radius like an input or button.
    }
    &.rounded-inset .overlay {
        border-radius: $inset-section-border-radius; //Covering an inset section like AccentBox, etc.
    }
}

@keyframes overlay {
    0% {
        background-position: 0% 0%;
    }
    25% {
        background-position: 100% 0%;
    }
    50% {
        background-position: 100% 100%;
    }
    75% {
        background-position: 0% 100%;
    }
    100% {
        background-position: 0% 0%;
    }
}

</style>